<template>
  <Layout
    :errors="errors"
    :title="trans(`models.${resourceType}.content.edit.action`)"
    :toasts="toasts"
    :resource="model"
  >
    <div v-if="model.data" class="card rounded-corner">
      <div class="card-body">
        <div class="model-title-bar">
          <div class="flex row pe-2">
            <div class="col flex-grow-1">
              <h5 class="card-title text-primary fw-bold text-uppercase">
                {{ trans(`models.${resourceType}.content.edit.action`) }}
              </h5>
            </div>

            <resource-action-buttons
              :button-class="'btn btn-primary text-secondary'"
              :model="model"
              :resource-type="resourceType"
              :source-action="'edit'"
            ></resource-action-buttons>
          </div>
          <div v-if="hasDescription(trans)" class="card rounded-corner">
            <div class="card-body">
              <p class="card-text">
                {{ trans(`models.${resourceType}.content.index.description`) }}
              </p>
            </div>
          </div>
        </div>
        <p class="card-text">
          {{ trans(`models.${resourceType}.content.edit.description`) }}
        </p>
        <resource-form :errors="errors" :resource="model" @update:toasts="addToasts($event)"></resource-form>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/structures/moviary/Pages/Layout';
import ResourceForm from '@/structures/default/components/ResourceForm';
import ResourceActionButtons from '@/structures/default/components/Links/ResourceActionButtons';
import useResource from '@/structures/default/composables/useResource';
import useToasts from '@/structures/default/composables/useToasts';

export default {
  components: {
    Layout,
    ResourceForm,
    ResourceActionButtons,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    logEntries: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  emits: ['update:toast'],
  setup(props) {
    const { resourceType } = useResource(props, props.model);
    const { addToasts } = useToasts(props);

    const hasDescription = (trans) => {
      let transString = `models.${props.resourceType}.content.index.description`;
      let translation = trans(transString);

      return translation && translation !== transString;
    };

    return {
      addToasts,
      hasDescription,
      resourceType,
    };
  },
};
</script>
